import { Link } from "react-router-dom";
import { SUPPORT_MAILTO } from "../contact";
import { LogoMark } from "../Logo";
import { Icon } from "../components/Icon";

export function Login() {
  return (
    <div className="auth">
      <div className="box">
        <div className="logo-badge">
          <LogoMark size={30} />
        </div>
        <h1>Caldwell School Lunch</h1>
        <p>
          Forward a Google&nbsp;Forms lunch-order receipt and it turns into
          calendar events — on the calendar you pick, at the time you set.
        </p>
        <a className="btn block" href="/auth/google">
          <Icon name="user" size={16} />
          Continue with Google
        </a>
        <div className="legal">
          <Link to="/about">How it works</Link>
          {"  ·  "}
          <Link to="/privacy">Privacy Policy</Link>
          {"  ·  "}
          <Link to="/terms">Terms of Service</Link>
          {"  ·  "}
          <a href={SUPPORT_MAILTO}>Contact</a>
        </div>
      </div>
    </div>
  );
}
